function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { Skeleton, Card, Button, message, Space, Select, Form, List, DatePicker, Input, Modal, notification } from 'antd';
import { Container, Row, Col } from 'react-bootstrap';
import Common from './includes/Common';
import { FileEarmarkFill, BookHalf, ShareFill } from 'react-bootstrap-icons';
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import moment from 'moment';
import AddDocumentShare from './forms/AddDocumentShare';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var WorkbookInsideView = function WorkbookInsideView(_ref) {
  var workbook = _ref.workbook;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    documentsList = _useState4[0],
    setDocumentsList = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedDocument = _useState6[0],
    setSelectedDocument = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    keyWords = _useState8[0],
    setKeyWords = _useState8[1];
  var _useState9 = useState(moment().startOf('year').format()),
    _useState0 = _slicedToArray(_useState9, 2),
    from = _useState0[0],
    setFrom = _useState0[1];
  var _useState1 = useState(moment().endOf('year').format()),
    _useState10 = _slicedToArray(_useState1, 2),
    to = _useState10[0],
    setTo = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isShareBoxVisible = _useState12[0],
    setIsShareBoxVisible = _useState12[1];
  var _useState13 = useState(1),
    _useState14 = _slicedToArray(_useState13, 2),
    displayType = _useState14[0],
    setDisplayType = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isDataChanged = _useState16[0],
    setIsDataChanged = _useState16[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    dform = _Form$useForm2[0];
  var handleDisplayChange = function handleDisplayChange(d) {
    setDisplayType(d);
  };
  var handleDocumentShare = function handleDocumentShare(d) {
    setSelectedDocument(d);
    setIsShareBoxVisible(true);
  };
  useEffect(function () {
    setIsDataLoading(true);
    setIsDataChanged(false);
    dform.setFieldsValue({
      display_type: 1
    });
    axios.get("".concat(Common.baseApiUrl, "getdocumentsfromworkbook/").concat(workbook.id, "/").concat(Common.currentUser.id)).then(function (response) {
      if (response.data.status == 200) {
        setDocumentsList(response.data.documents);
      } else {
        message.error({
          content: response.data.message,
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      fluid: true,
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsxs(Col, {
          lg: 7,
          md: 6,
          children: [/*#__PURE__*/_jsx(Space, {
            direction: "horizontal",
            style: {
              borderRadius: '5px',
              width: '100%',
              background: '#A0DB80',
              padding: '5px'
            },
            children: /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                children: /*#__PURE__*/_jsx(Form, {
                  form: dform,
                  size: "middle",
                  layout: "vertical",
                  children: /*#__PURE__*/_jsx(Form.Item, {
                    name: "display_type",
                    label: "Affichage par",
                    children: /*#__PURE__*/_jsx(Select, {
                      onChange: handleDisplayChange,
                      style: {
                        width: '200px'
                      },
                      options: [{
                        value: 1,
                        label: "Grilles"
                      }, {
                        value: 2,
                        label: "Liste"
                      }]
                    })
                  })
                })
              }), /*#__PURE__*/_jsxs(Col, {
                lg: 8,
                md: 8,
                children: [/*#__PURE__*/_jsx(Form, {
                  form: dform,
                  size: "middle",
                  layout: "vertical",
                  children: /*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 8,
                      md: 8,
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "period",
                        label: "Fitrer par p\xE9riode",
                        children: /*#__PURE__*/_jsx(RangePicker, {
                          showTime: true
                        })
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        label: " ",
                        children: /*#__PURE__*/_jsx(Button, {
                          htmlType: "submit",
                          type: "default",
                          children: /*#__PURE__*/_jsx("b", {
                            children: "CHERCHER"
                          })
                        })
                      })
                    })]
                  })
                }), /*#__PURE__*/_jsx(Input, {
                  placeholder: "Entrer le nom ou description du document"
                })]
              })]
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(List, {
            grid: displayType == 1 ? {
              gutter: 16,
              column: 3
            } : null,
            loading: isDataLoading,
            dataSource: documentsList,
            itemLayout: "horizontal",
            renderItem: function renderItem(item) {
              return /*#__PURE__*/_jsx(List.Item, {
                actions: displayType == 2 ? [/*#__PURE__*/_jsx("a", {
                  onClick: function onClick() {
                    setSelectedDocument(item);
                  },
                  children: /*#__PURE__*/_jsxs("b", {
                    children: [/*#__PURE__*/_jsx(BookHalf, {
                      size: 20
                    }), " CONSULTER"]
                  })
                }), /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  size: "small",
                  onClick: function onClick() {
                    handleDocumentShare(item);
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(ShareFill, {
                      size: 16
                    })
                  })
                })] : null,
                children: displayType == 1 ? /*#__PURE__*/_jsx(Card, {
                  size: "middle",
                  title: /*#__PURE__*/_jsxs("b", {
                    children: [/*#__PURE__*/_jsx(FileEarmarkFill, {
                      style: {
                        color: item.workbook.color
                      },
                      size: 20
                    }), item.title]
                  }),
                  style: {
                    width: '100%'
                  },
                  bodyStyle: {
                    background: '#EEE',
                    borderRadius: '0px'
                  },
                  headStyle: {
                    background: '#EEE'
                  },
                  actions: [/*#__PURE__*/_jsx(Button, {
                    onClick: function onClick() {
                      setSelectedDocument(item);
                    },
                    type: "link",
                    children: /*#__PURE__*/_jsxs("b", {
                      children: [/*#__PURE__*/_jsx(BookHalf, {
                        size: 20
                      }), " CONSULTER"]
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    size: "small",
                    onClick: function onClick() {
                      handleDocumentShare(item);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(ShareFill, {
                        size: 16
                      })
                    })
                  })],
                  children: /*#__PURE__*/_jsxs("p", {
                    children: [item.description.substring(0, 96), " ..."]
                  })
                }) : /*#__PURE__*/_jsx(Skeleton, {
                  avatar: true,
                  title: false,
                  loading: isDataLoading,
                  active: true,
                  children: /*#__PURE__*/_jsx(List.Item.Meta, {
                    avatar: /*#__PURE__*/_jsx(FileEarmarkFill, {
                      style: {
                        color: item.workbook.color
                      },
                      size: 30
                    }),
                    title: /*#__PURE__*/_jsx("b", {
                      children: item.title
                    }),
                    description: item.description
                  })
                })
              });
            }
          }), /*#__PURE__*/_jsx("br", {})]
        }), /*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 6,
          children: /*#__PURE__*/_jsx("div", {
            children: selectedDocument == null ? /*#__PURE__*/_jsx("div", {
              style: {
                background: '#EEE',
                textAlign: 'center',
                padding: '200px 0px',
                color: '#9AA2A9'
              },
              children: /*#__PURE__*/_jsx("h2", {
                children: "PREVISUALISATION"
              })
            }) : /*#__PURE__*/_jsxs("div", {
              style: {
                background: '#EEE',
                textAlign: 'center',
                padding: '0px 0px'
              },
              children: [/*#__PURE__*/_jsx("div", {
                style: {
                  textAlign: 'center'
                },
                children: /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  href: selectedDocument.location,
                  target: "_blank",
                  block: true,
                  size: "small",
                  children: /*#__PURE__*/_jsx("b", {
                    children: "TELECHARGER"
                  })
                })
              }), /*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: selectedDocument.title
                })
              }), /*#__PURE__*/_jsx("p", {
                children: selectedDocument.description
              }), /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsx("b", {
                    children: "Auteur(e) : "
                  }), selectedDocument.user.prenom + " " + selectedDocument.user.nom]
                }), /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsx("b", {
                    children: "Taille (mb) : "
                  }), Math.round(selectedDocument.size * 0.00001)]
                })]
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
                children: /*#__PURE__*/_jsx(DocViewer, {
                  documents: [{
                    uri: Common.baseUrl + selectedDocument.location
                  }],
                  pluginRenderers: DocViewerRenderers,
                  language: "fr",
                  config: {
                    header: {
                      disableHeader: false,
                      disableFileName: true
                    }
                  }
                })
              })]
            })
          })
        })]
      })
    }), selectedDocument != null && /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsxs("b", {
        children: ["PARTAGER - ", selectedDocument.title]
      }),
      width: "400px",
      destroyOnClose: true,
      footer: null,
      open: isShareBoxVisible,
      onCancel: function onCancel() {
        setIsShareBoxVisible(false);
      },
      children: /*#__PURE__*/_jsx(AddDocumentShare, {
        handler: function handler() {
          setIsDataChanged(true);
          notification.success({
            message: "Opération réussie",
            description: "Le classeur à été partagé avec succès"
          });
          setIsShareBoxVisible(false);
        },
        document: selectedDocument
      })
    })]
  });
};
export default WorkbookInsideView;